import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { BaseLocationsSelectSearch } from 'src/components/SelectSearch/BaseLocationsSelectSearch';
import { ILocation } from 'src/types/Location';
import {
  MAX_LOCATIONS_ALLOWED,
  maxLocationsAllowedValidation,
} from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/LocationsSelectControl/LocationsSelectControl.utils';

interface LocationsSelectControlProps {
  name: string;
}

export const LocationsSelectControl: React.FC<LocationsSelectControlProps> = ({
  name,
}) => {
  const { setValue } = useFormContext();
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <BaseLocationsSelectSearch
      name={name}
      corpId={corpId}
      label={`Add up to ${MAX_LOCATIONS_ALLOWED} locations`}
      rules={{
        validate: {
          maxLocations: maxLocationsAllowedValidation(MAX_LOCATIONS_ALLOWED),
        },
      }}
      onValueChange={(locations: ILocation[] = []): void => {
        setValue(name, locations, { shouldValidate: true });
      }}
    />
  );
};
